import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/copy-icon.svg'
import _imports_1 from '@/assets/external-link-line.svg'


const _hoisted_1 = { class: "rs-button-container" }
const _hoisted_2 = { class: "rs-button-copy" }
const _hoisted_3 = ["href"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  class: "img-fluid",
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = ["href"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  class: "img-fluid",
  src: _imports_1,
  alt: "External link"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", {
        class: "wrap-text rs-button-resource",
        href: _ctx.resource,
        target: "_blank"
      }, _toDisplayString(_ctx.resource), 9, _hoisted_3),
      _createElementVNode("div", {
        class: "rs-button-copy-icon rs-button-hover",
        title: "Copy URI",
        role: "button",
        tabindex: "0",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.copyResource()))
      }, _hoisted_5)
    ]),
    _createElementVNode("a", {
      class: "rs-button-rs rs-button-hover",
      href: _ctx.externalUrl,
      target: "_blank"
    }, [
      _createTextVNode(_toDisplayString(_ctx.$t("ResearchSpaceButton.view_resource_on")) + " ", 1),
      _hoisted_7
    ], 8, _hoisted_6)
  ]))
}